import React, { Component } from 'react';
import { Tooltip } from 'antd';
import PropTypes from 'prop-types';
import _ from 'lodash';
import './OneRowData.style.less';
class OneRowData extends Component {
  _imageBtn = (fileURL, data) => (
    <div className={`img-wrapper visible ${data.class || ''}`}>
      <button
        type="button"
        onClick={() => {
          data.callback(fileURL, data.fileName);
        }}
      >
        <img id="agent-photo" src={data.url} alt="" />
      </button>
    </div>
  );

  renderImage() {
    const { data } = this.props;
    const icon = data.label.includes('Icon') ? 'icon' : '';
    let img = '';
    if (Array.isArray(data.url)) {
      img = data.url.map(url => (
        <div
          key={url}
          className={`img-wrapper visible ${data.class || ''} ${icon}`}
          style={{ ...data.style }}
        >
          <img id="agent-photo" src={url} alt="" />
        </div>
      ));
    } else if (data.url) {
      // For Auto Download - acquisition detail
      if (data.callback) {
        const tempGetUrl = data.url.split(data.fileName);
        const fileURL = `${tempGetUrl[0]}${data.fileName}`;
        img = this._imageBtn(fileURL, data);
      } else {
        img = (
          <div
            className={`img-wrapper visible ${data.class || ''} ${icon}`}
            style={{ ...data.style }}
          >
            <img id="agent-photo" src={data.url} alt="" />
          </div>
        );
      }
    }

    return img;
  }

  render() {
    const { data } = this.props;
    const initClassing = data.url ? 'one-row column-style' : 'one-row';
    let onerowClass = data.class
      ? `${initClassing} ${data.class}`
      : initClassing;
    const valueClass = data.valueCustomClass ? data.valueCustomClass : 'value';
    const classInline = data.inline ? 'inline-block' : '';
    if (_.get(data, 'value.length', 0) > 50 && !data.elipsis) {
      onerowClass = data.class
        ? `one-row long-text ${data.class}`
        : 'one-row long-text';
    }

    return (
      <div className={onerowClass}>
        <span className="label">{data.label}</span>

        {data.elipsis ? (
          <Tooltip title={data.value}>
            <span className={valueClass}>{data.elipsis}</span>
          </Tooltip>
        ) : (
          <div className={classInline}>
            <span className={valueClass}>{data.value}</span>
            {data.node && data.node()}
            {this.renderImage()}
          </div>
        )}
      </div>
    );
  }
}

OneRowData.propTypes = {
  data: PropTypes.object,
};

export default OneRowData;
